/** Excel 打标会话草稿：关弹窗后仍可恢复 scope，不存 xlsx 本体 */
const STORAGE_KEY = 'link-batch-tag-excel-draft'
/** 超过 7 天视为过期，避免长期残留误导运营 */
const MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000

function padTwo(n) {
  return String(n).padStart(2, '0')
}

export function formatDraftExportedLabel(timestamp) {
  if (!timestamp) {
    return ''
  }
  const date = new Date(timestamp)
  if (Number.isNaN(date.getTime())) {
    return ''
  }
  return `${date.getMonth() + 1}月${date.getDate()}日 ${padTwo(date.getHours())}:${padTwo(date.getMinutes())}`
}

/**
 * 读取 sessionStorage 中的 Excel 打标草稿；无效或过期返回 null。
 */
export function readBatchTagDraft() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    if (!raw) {
      return null
    }
    const draft = JSON.parse(raw)
    if (!draft || !Array.isArray(draft.scopeKeySet) || !draft.scopeKeySet.length) {
      return null
    }
    if (draft.exportedAt && Date.now() - draft.exportedAt > MAX_AGE_MS) {
      clearBatchTagDraft()
      return null
    }
    return draft
  } catch (error) {
    return null
  }
}

/** 写入草稿：仅 scopeKeySet、模式、导出时间等轻量字段 */
export function writeBatchTagDraft(draft) {
  if (!draft || !Array.isArray(draft.scopeKeySet) || !draft.scopeKeySet.length) {
    return
  }
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(draft))
}

export function clearBatchTagDraft() {
  try {
    sessionStorage.removeItem(STORAGE_KEY)
  } catch (error) {
    // sessionStorage 不可用时静默失败
  }
}
